var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.contents.content.alignment || 'left'},[_c('a',{staticClass:"botao",attrs:{"href":_vm.file,"target":"_blank"}},[_vm._v(_vm._s(_vm.contents.content.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }